<template>
  <div>
    <h2>Resumen de Indicadores</h2>
    <div style="margin-bottom:1em;">
      <label>Filtrar por código: </label>
      <select v-model="filtroCodigo" @change="fetchResumen" class="codigo-dropdown">
        <option value="">Todos</option>
        <option v-for="codigo in codigosDisponibles()" :key="codigo" :value="codigo">{{ codigo }}</option>
      </select>
    </div>
    <div class="csb-table-wrapper">
      <table v-if="resumen.length" class="csb-table">
        <thead>
          <tr>
            <th class="clickable-header white-header">Código</th>
            <th class="clickable-header white-header" style="text-align:right;">Valor</th>
            <th class="clickable-header white-header" style="text-align:right;">Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ind, idx) in resumen" :key="ind.id" :class="{ 'odd-row': idx % 2 === 0, 'even-row': idx % 2 !== 0 }">
            <td>{{ ind.codigo }}</td>
            <td style="text-align:right;">{{ formatCurrency(ind.valor) }}</td>
            <td style="text-align:right;">{{ formatFecha(ind.fecha) }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else>Cargando o sin resultados...</div>
    </div>
  </div>
</template>

<script>
import apiClient from '@/api/index';

export default {
  name: 'ResumenIndicadores',
  inject: ['codigosDisponibles', 'fetchCodigos'],
  data() {
    return {
      resumen: [],
      filtroCodigo: '',
    };
  },
  mounted() {
    this.fetchResumen();
    this.fetchCodigos();
  },
  methods: {
    async fetchResumen() {
      let url = '/indicadores/?limit=100&order=desc';
      if (this.filtroCodigo) {
        url += `&codigo=${encodeURIComponent(this.filtroCodigo)}`;
      }
      try {
        const res = await apiClient.get(url);
        this.resumen = res.data;
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.resumen = [];
          this.$emit('not-authenticated');
          alert('Debes iniciar sesión para ver los indicadores.');
        } else {
          this.resumen = [];
        }
      }
    },
    formatCurrency(valor) {
      if (valor === null || valor === undefined) return '-';
      return Number(valor).toLocaleString('es-CL', { style: 'currency', currency: 'CLP', minimumFractionDigits: 2 });
    },
    formatFecha(fecha) {
      if (!fecha) return '';
      const d = new Date(fecha);
      const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
      return `${d.getDate().toString().padStart(2, '0')}-${meses[d.getMonth()]}-${d.getFullYear()}`;
    },
  },
};
</script>

<style scoped>
.csb-table-wrapper {
  width: 50%;
  margin-left: 0;
  margin-right: auto;
}
.csb-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
}
.csb-table thead {
  background-color: #333;
  color: #fff;
}
.csb-table th, .csb-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
.csb-table th {
  font-weight: bold;
}
.csb-table .odd-row {
  background-color: #f9f9f9;
}
.csb-table .even-row {
  background-color: #fff;
}
.clickable-header {
  cursor: pointer;
  text-decoration: underline;
  color: #0078d4;
  transition: color 0.2s;
}
.clickable-header:hover {
  color: #22c55e;
}
.white-header {
  color: #fff !important;
}
.codigo-dropdown {
  min-width: 140px;
  padding: 0.4em 0.7em;
  border-radius: 6px;
  border: 1px solid #bbb;
  font-size: 1em;
  margin-left: 0.5em;
}
</style>
